import { ThinkingStepData } from "~shared/types/thinking-step-types";
import InlineSVG from "react-inlinesvg";

export const getProseActionIcon = (passage: string | undefined, tasks: ThinkingStepData["tasks"] | undefined) => {
  if (passage && tasks && tasks.length > 0) {
    return <InlineSVG src="/assets/rewrite-icon.svg" height={22} width={22} className="w-6 h-6 [&_path]:fill-app-primary-cta-high-contrast" />;
  }
  return null;
};
